import { SET_SITE_DATA, SET_PAGE,SET_MEIN_TRAINING_MODAL,SET_PROGRAM_LIST, SET_HOMEPAGE_DATA,SET_HEADER_TEXT_COLOR,SET_HEART_DATA, SET_USER_DATA, SET_LOADING, SET_CART_DATA,SET_COUPON_DATA,SET_HEADER_COLOR,SET_CART_DETAILS,SET_SECTION2,SET_LANGUAGE_LOAD,SET_RECIPE_PLAN } from "./Action";

const initialState = {
    siteData: {},
    userData: {},
    page: "",
    isLoading: true,
    homePage: {},
    cartData: [],
    heartData: [],
    couponData: null,
    headerColor:"#99d9de",
    headerTextColor:"#212529",
    cartDetails:{},
    programListing:[],
    section2: "", 
    languageLoad:"de",
    meinTrainingModal:false,
    recipePlan:[]

};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_SITE_DATA:
            return { ...state, siteData: payload };
        case SET_PAGE:
            return { ...state, page: payload };
        case SET_HOMEPAGE_DATA:
            return { ...state, homePage: payload };
        case SET_USER_DATA:
            return { ...state, userData: payload };
        case SET_LOADING:
            return { ...state, isLoading: payload };
        case SET_CART_DATA:
            return { ...state, cartData: payload };
        case SET_HEART_DATA:
            return { ...state, heartData: payload };
        case SET_COUPON_DATA:
            return { ...state, couponData: payload };
        case SET_LANGUAGE_LOAD:
            return { ...state, languageLoad: payload };
        case SET_HEADER_COLOR:
            return { ...state, headerColor: payload };
        case SET_HEADER_TEXT_COLOR:
            return { ...state, headerTextColor: payload };
        case SET_CART_DETAILS:
            return { ...state, cartDetails: payload };
        case SET_SECTION2: // fixed state key here
            return { ...state, section2: payload }; 
        case SET_MEIN_TRAINING_MODAL: // fixed state key here
            return { ...state, meinTrainingModal: payload };
         case SET_PROGRAM_LIST: // fixed state key here
            return { ...state, programListing: payload }; 
        case SET_RECIPE_PLAN: // fixed state key here
            return { ...state, recipePlan: payload }; 
        default:
            return state;
    }
}


export default reducer